import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InternalQuoteForm from "../Form/InternalQuoteForm";
import { useState } from "react";
import FormSpinner from "../../../avis/formControl/formSpinner";
import { SelectedOrderTable } from "../OrdersMaterialTable/SelectedOrderTable";
import { log } from "../../../Helper";
import { toast } from "react-toastify";
import { Button } from "@deere/fuel-react";
import { setStartQuote } from "../../api";
import _ from "lodash";


const InternalQuoteDialog = (props) => {
  const {
    open,
    handleClose,
    selectedMachineForQuote,
    getTableData,
    preSelectedProvider
  } = props;

  const [startSpinner, setStartSpinner] = useState(false);
  const [selectedProviderList, setSelectedProviderList] = useState([]);
  const [uncheckedInitialProviders, setUncheckedInitialProviders] = useState([]);
  const [newlySelectedProviders, setNewlySelectedProviders] = useState([]);

  const handleCloseSpinner = (event, reason) => {
    if (reason !== "backdropClick") {
      setStartSpinner(false);
    }
  };

  //disabled the apply button if no selected providers or selected provider list has only AAA_SELECT.
  function isDisabled() {
    return ((selectedProviderList.length === 0) ||
      ((!_.isEmpty(preSelectedProvider) 
      ? preSelectedProvider.split(", ").map(Number).includes(101)
        : false) &&
        (!_.isEmpty(preSelectedProvider) ? selectedProviderList.length === 1
        : false))
    );
  }

  const handleApply = (selectedOrders, providerList) => {
    setStartSpinner(true);
    const reqObject = {
      startQuoteMachineDTOList: selectedOrders,
      //removed preselected to avoid duplicated entry in zipcost (can be replaced by newlyselected)
      providerList: !_.isEmpty(preSelectedProvider) ? providerList.filter(element => !preSelectedProvider.split(', ').map(Number).includes(element)) : providerList,
      newlySelectedProvidersList : newlySelectedProviders, // new provider added as a preselected
      uncheckedInitialProvidersList : uncheckedInitialProviders // provider list removed as a preselected provider
    }
    setStartQuote(reqObject).then((response) => {
      log(response);
      if (response.httpResponse === 200) {
        toast.success(response.message);
        getTableData();
        setStartSpinner(false);
        handleClose();
      } else {
        toast.error(response.message);
        // getTableData();
        setStartSpinner(false);
        handleClose();
      }
    });
  }

  const handleSelectedProvider = (e) => {
    log("Selected provider in internal quote :: ",e)
    setSelectedProviderList(e);
  }

  const handleSelectedProviderUpdate = (e1, e2) => {
    log("Selected provider in internal quote :: handleSelectedProviderUpdate ",e1, e2)
    setUncheckedInitialProviders(e1);
    setNewlySelectedProviders(e2);
  }

  return (
    <>
      <div id="quote-dialog-div1" className=" w-[40%]">
        <Dialog
          id="quote-dialog1"
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title1">
            {"PROVIDER SELECTION"}
          </DialogTitle>
          <DialogContent id="quote-dialog-content1">
            <SelectedOrderTable selectedMachines={selectedMachineForQuote} />
            <InternalQuoteForm
              onProviderSelection={handleSelectedProvider}
              preSelectedProvider={preSelectedProvider}
              onProviderSelectionUpdate = {handleSelectedProviderUpdate}
            />
          </DialogContent>
          <DialogActions
            id="quote-dialog-actions1"
            style={{ justifyContent: "center" }}
          >
            <Button
              id="quote-apply-btn"
              variant="primary"
              size="small"
              onClick={() =>
                handleApply(selectedMachineForQuote, selectedProviderList)
              }
              disabled={isDisabled()}
            >
              Apply
            </Button>
            <Button
              id="quote-cancel-btn"
              variant="secondary"
              size="small"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <FormSpinner
          startSpinner={startSpinner}
          handleCloseSpinner={handleCloseSpinner}
        />
      </div>
    </>
  );

 
};

export default InternalQuoteDialog;
